import React,{useRef} from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { Tabindex }from '../../../utils/typeConstants'
import { Template,Country,Category,Role } from '../type'

interface CaSearchDataTablePropsTypes  {
    searchedTemplatesData:[],
    setActiveIndex:(e:number)=>void,
    setSelectedCountry: (e: Country) => void;
    setSelectedCategory: (e: Category) => void;
    setSelectedRole: (e: Role) => void;
    setSelectedCaTemplate:(e:Template) => void;
    setIsUpdateApprovalQueues: (e: boolean) => void;
    setSelectedLanguage: (e:number) => void;
}


export const CaSearchDataTable = ({
    searchedTemplatesData,
    setActiveIndex,
    setSelectedCountry,
    setSelectedCategory,
    setSelectedRole,
    setSelectedCaTemplate,
    setIsUpdateApprovalQueues,
    setSelectedLanguage
}:CaSearchDataTablePropsTypes) => {

    const menu = useRef<Menu>(null);
    const items = [];
    items.push(
        {
            label: 'Configure Template',
            icon: 'pi pi-pencil',
            visible: true,
            command: () => {
                setActiveIndex(Tabindex.Configuration);              
            },
        },
        { separator: true, visible: true },
        {
            label: 'Configure Approval Queues',
            icon: 'pi pi-pencil',
            visible: true,
            command: () => {               
                setIsUpdateApprovalQueues(true);
                setActiveIndex(Tabindex.Create);
            },
        }
    );
    const popupMenuClickHandler = (e: any,rowData:any) => {
        e.preventDefault();
        menu.current?.toggle(e);
        setConfigureTemplateValues(rowData);
    };

    const setConfigureTemplateValues = (rowData:any) =>{           
        const country = {
            "country_id":rowData.country_id,
            "country_name":rowData.country_name,
        }
        setSelectedCountry(country);

        const category = {
            "ca_category_id":rowData.ca_category_id,
            "ca_category_name":rowData.ca_category_name,
        }
        setSelectedCategory(category);

        const role = {
            "scorecard_role_id":rowData.scorecard_role_id,
            "scorecard_role_name":rowData.scorecard_role_name,
        }
        setSelectedRole(role);

        const template = {
            "ca_template_id":rowData.ca_template_id,
            "ca_template_name":rowData.ca_template_name,
        }
        setSelectedCaTemplate(template);

        setSelectedLanguage(rowData?.default_emp_language_id);
    }

    const actionTemplate = (rowData: any) => {
        if (rowData !== null)
            return (
                <Button
                    type="button"
                    icon="pi pi-ellipsis-v"
                    onClick={(e: any) => {
                        popupMenuClickHandler(e, rowData);
                    }}
                />
            );
            return (<div/>)
    };
    const renderHeader = () => {
        return (
            <div className="table-heading mb-1">
                <p>Search Result</p>
            </div>
        );
    };

    const header = renderHeader();

    return (
        <>
            <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
            <div className="my-1">
                <DataTable
                    header={header}
                    value={searchedTemplatesData}
                    className="ca-search-table"
                    scrollable
                >
                     <Column                       
                        header="Name"
                        field='ca_template_name'                       
                        sortable
                        sortField='ca_template_name'
                    />
                    <Column                       
                        header="Country"
                        field='country_name'
                        sortable
                        sortField='country_name'
                    />
                    <Column
                        header="Category"                        
                        field='ca_category_name'
                        sortable
                        sortField='ca_category_name'
                    />
                    <Column
                        header="Roles"
                        field='scorecard_role_name'
                        sortable
                        sortField='scorecard_role_name'
                    />
                    <Column
                        body={actionTemplate}
                    />
                </DataTable>
            </div>
        </>
    )
}
